import { toasterMsg } from '../../../Components/Toaster/Toaster';
import t from './SupplierSuggestion.type';
import * as SupplierSuggestion from '../../../services/supplierSuggestion.service';
import * as BOMConfigService from '../../../services/bom-config.service';
import * as SupplierService from '../../../services/supplier.service';
import * as MasterService from '../../../services/SystemMaster.services';
import * as SupplierToDoService from '../../../services/supplierToDo.services';
import { getSelectedGradGroupData } from '../../../services/developmentOrder.service';

export const fetchSupplierSuggestionList = (params) => async () => {
  try {
    const res = await SupplierSuggestion.getSupplierSuggestion(params);
    if (res.code === 200) {
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getComponentType = (params) => async () => {
  try {
    const res = await SupplierSuggestion.getComponent(params);
    if (res.code === 200) {
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCompositionComponent = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getComposition(data);
    if (res.code === 200) {
      await dispatch({
        type: t.COMPOSITION_COMPONENT,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierSuggestUnits = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getUnits(data);
    if (res.code === 200) {
      await dispatch({
        type: t.UNITS,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllBOMComponent = (BOMTypeId, devOrderId, query) => async () => {
  try {
    const res = await BOMConfigService.getBomConfigCards(BOMTypeId, devOrderId, query);
    if (res.code === 200) {
      return res.data.doc;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierProductRef = (id) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getProductRef(id);
    if (res.code === 200) {
      await dispatch({
        type: t.PRODUCTREF,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierSuggestSupplier = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSupplier(data);
    if (res.code === 200) {
      await dispatch({
        type: t.SUPPLIER_DATA,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getBomTypeProductRef = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getBomType(data);
    if (res.code === 200) {
      await dispatch({
        type: t.BOM_TYPE,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getBomComponentProductRef = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getBomComponent(data);
    if (res.code === 200) {
      await dispatch({
        type: t.BOM_COMPONENT,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const AddSuggestion = (data, transaction) => async () => {
  try {
    const res = await SupplierSuggestion.addSupplierSuggestion(data);
    if (res.code === 200) {
      const msg = transaction(`SUPPLIER_SUGGESTION.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSuggestionList = (data) => async () => {
  try {
    const res = await SupplierSuggestion.getSupplierSuggestionList(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSuggestionDetail = (data, transMsg) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSupplierSuggestionDetail(data);
    if (res.code === 200) {
      await dispatch({
        type: t.SET_SUGGESTION_DETAILS,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(transMsg(res?.data?.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteSupplier = (id, transaction) => async () => {
  try {
    const res = await SupplierSuggestion.deleteSuggestion(id);
    if (res.code === 200) {
      const msg = transaction(`SUPPLIER_SUGGESTION.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// testing suggestion actin collection

export const getBomComponentRefCodes = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getBomComponentRefCodes(data);
    if (res.code === 200) {
      await dispatch({
        type: t.TESTING_BOM_COMPONENT,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getColourWays = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getColourWays(data);
    if (res.code === 200) {
      await dispatch({
        type: t.COLOUR_WAYS,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const approveRejectSuggestion = (action, data, transaction) => async (dispatch) => {
  try {
    let res = null;
    if (action === 'Approved') {
      res = await SupplierSuggestion.approveSuggestion(data);
    }
    if (action === 'Rejected') {
      res = await SupplierSuggestion.rejectSuggestion(data);
    }
    if (res.code === 200) {
      const msg = transaction(`SUPPLIER_SUGGESTION.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');

      if (res.data?.errTemplates?.length > 0 || res.data?.removedElements?.length > 0) {
        dispatch(setDuplicateCodeModal(true, res.data));
      }

      return res;
    }
    toasterMsg(transaction(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTestingLibraries = (data, isToFilterSuggestion) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getTestingLibraries(data, isToFilterSuggestion);
    if (res.code === 200) {
      await dispatch({
        type: t.TESTING_LIBRARIES,
        payload: res.data.doc,
      });
      return res.data.doc;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTestingLibraryById = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getTestingLibraryById(data);
    if (res.code === 200) {
      await dispatch({
        type: t.TESTING_LIBRARIES_FORM_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMeasurementSuggestion = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getMeasurementById(data);
    if (res.code === 200) {
      return [res.data?.measurements];
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSelectedGradGroupDataSupplier = (params) => async (dispatch) => {
  try {
    const res = await getSelectedGradGroupData(params);
    if (res.code === 200) {
      await dispatch({
        type: t.SET_MEASUREMENT,
        payload: [res.data],
      });
      return [res.data];
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const measurementSuggestionAction = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_MEASUREMENT,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMeasurementPermission = (data) => async () => {
  try {
    const res = await SupplierSuggestion.getMeasurementPermissionByID(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getHideShowGrading = (id, data) => async () => {
  try {
    const res = await SupplierSuggestion.getHideShowGradingByID(id, data);
    if (res.code === 200) {
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadSuggestionImage = (data) => async () => {
  try {
    const res = await SupplierSuggestion.uploadImage(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg('Please choose an image', 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unlinkUploadImage = (data) => async () => {
  try {
    const res = await SupplierSuggestion.unlinkImage(data);
    if (res.code === 200) {
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCareLabelPermission = (data) => async () => {
  try {
    const res = await SupplierSuggestion.getCareLabelPermissionByID(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCareLabelSuggestion = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getCareLabelById(data);
    if (res.code === 200) {
      await dispatch({
        type: t.SET_CARE_LABEL,
        payload: [res.data],
      });
      return [res.data];
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const careLabelSuggestionAction = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_CARE_LABEL,
      payload: [data],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateMeasurementSuggestion = (data) => async (dispatch) => {
  console.log('🚀 ~ file: SupplierSuggestion.action.js:416 ~ updateMeasurementSuggestion ~ data:', data);
  try {
    await dispatch({
      type: t.UPDATE_MEASUREMENT,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setDuplicateCodeModal = (data, errorCode) => async (dispatch) => {
  await dispatch({
    type: t.DUPLICTAE_MODAL,
    payload: { isOpen: data, code: errorCode },
  });
};

export const fetchAllBrandAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBrands(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.BRANDS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  const setValueObj = (label, value) => {
    return { label, value };
  };
  try {
    const res = await SupplierService.getAllCategory(params);
    if (res.code === 200 && res.data) {
      const category = await res.data.map((item) => {
        return setValueObj(item.label, item.value);
      });
      await dispatch({
        type: t.CATEGORY1,
        payload: category,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSeasonsAction = (id) => async () => {
  try {
    const res = await SupplierSuggestion.getSeasons(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSuggestionDetail = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSupplierSuggestionDetail(data);
    if (res.code === 200) {
      await dispatch({
        type: t.SET_SUPP_DATA_TO_UPDATE,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateSuggestion = (data, transaction) => async () => {
  try {
    const res = await SupplierSuggestion.updateSupplierSuggestion(data);
    if (res.code === 200) {
      const msg = transaction(`SUPPLIER_SUGGESTION.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getPlacementOptions = (data) => async (dispatch) => {
  try {
    const res = await MasterService.getAllPlacement(data);
    if (res.code === 200) {
      await dispatch({
        type: t.PLACEMENT_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getFinishedOptions = (data) => async (dispatch) => {
  try {
    const res = await MasterService.getAllFinals(data);
    if (res.code === 200) {
      await dispatch({
        type: t.FINISHED_OPTIONS,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllBOMComponentOptions = (data) => async (dispatch) => {
  try {
    const res = await SupplierToDoService.getAllComponentSubType(data);
    if (res.code === 200) {
      await dispatch({
        type: t.ALL_BOM_SUB_COMPONENT_OPTIONS,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearBomSupplierSuggestion = () => async (dispatch) => {
  try {
    dispatch({
      type: t.CLEAR_BOM_SUPPLIER_SUGGESTION,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getExistingSuggestion = (data) => async () => {
  try {
    const res = await SupplierToDoService.getExistingSuggestion(data);
    if (res.code === 200) {
      return res.data;
    }

    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
